import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api, { eur } from "@/lib/api";

export default function PaymentResult({ cancelled }) {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [st, setSt] = useState(null);
  const [gaveUp, setGaveUp] = useState(false);
  useEffect(() => {
    if (cancelled || !sid) return;
    let n = 0, stop = false;
    const tick = async () => {
      try {
        const r = (await api.get(`/payments/status/${sid}`)).data;
        setSt(r);
        if (r.payment_status === "paid" || r.payment_status === "expired" || stop) return;
        if (++n > 15) { setGaveUp(true); return; }
      } catch (e) {
        if (e.response?.status === 404 || ++n > 15) { setGaveUp(true); return; }
      }
      setTimeout(tick, 2000);
    };
    tick();
    return () => { stop = true; };
  }, [sid, cancelled]);
  const paid = st?.payment_status === "paid";
  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-cyan-100 flex items-center justify-center p-4" data-testid="payment-result">
      <div className="bg-white rounded-2xl shadow-lg p-6 max-w-md w-full text-center">
        <h1 className="text-xl font-bold text-slate-900">Blu Lodge Maldives</h1>
        {cancelled ? <p className="mt-4 text-slate-600" data-testid="payment-cancelled">Pagamento annullato · Payment cancelled</p>
          : paid ? <p className="mt-4 text-emerald-700 font-semibold" data-testid="payment-paid">Pagamento ricevuto: {st.label} {eur(st.amount)}. Grazie! · Payment received, thank you!</p>
          : gaveUp || !sid ? <p className="mt-4 text-amber-700" data-testid="payment-unknown">Non riusciamo a confermare il pagamento ora. Se l'addebito è avvenuto lo registreremo a breve. · We could not confirm the payment yet.</p>
          : st?.payment_status === "expired" ? <p className="mt-4 text-rose-600">Sessione scaduta · Session expired</p>
          : <p className="mt-4 text-slate-500" data-testid="payment-checking">Verifica del pagamento in corso… · Checking payment…</p>}
      </div>
    </div>
  );
}
